import { Link } from 'react-router-dom';
import React, { Component } from 'react';


export class Module extends Component {

    constructor(props) {
        super(props);

        this.getModule.bind(this);
    }

    getModule = (name) => {
        return (
            <div className="function-actions">
                <div className="bx--row">
                    <div className="title--medium">{name}</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div
                className={"bx--coll-lg-4 bx--coll-md-2 functions button-tab-custom-content-function" + (this.props.multiline ? 'multiline' : '')}
            >
                {this.props.isExternal ?
                    <a href={this.props.path} target="_blank" className="bx--underline-none">
                        {this.getModule(this.props.name)}
                    </a>
                    :
                    <Link to={this.props.path} className="bx--underline-none">
                        {this.getModule(this.props.name)}
                    </Link>
                }

            </div>
        );
    }
}